<div class="table-container mat-elevation-z4">
  <div class="table-scroller" [style.height]="table.tableHeight$ | async">

    @if (table.busy$ | async) {
      <div class="spinner-container">
        <mat-spinner style="margin: 0 auto;"></mat-spinner>
      </div>
    }

    <mat-table matSort [dataSource]="dataSource" [matSortActive]="table.sortColumn$ | async" [matSortDirection]="table.sortDirection$ | async" (matSortChange)="table.sortChange($event)">

      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef class="w-14 flex-none">
          <mat-checkbox
            (change)="$event ? table.toggleAll() : null"
            [checked]="table.selectionAny$ | async"
          [indeterminate]="table.selectionIndeterminate$ | async"></mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="w-14 flex-none">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? table.toggle(row.id) : null"
          [checked]="(table.selection$ | async).indexOf(row.id) !== -1"></mat-checkbox>
        </mat-cell>
      </ng-container>

      @for (column of table.columnDefinitions; track column) {
        <ng-container [matColumnDef]="column.id">
          <mat-header-cell *matHeaderCellDef [mat-sort-header]="column.sort" [disabled]="!column.sort" [start]="column.defaultSortDirection ?? 'asc'" class="flex-dynamic" [style.flex]="'1 0 ' + column.width + 'px'">
            {{ column.caption }}
          </mat-header-cell>
          <mat-cell *matCellDef="let entity" style="flex: 1 0 {{ column.width }}px">
            @if (!!column.render) {
              <span>{{ column.render(entity) }}</span>
            }
          </mat-cell>
        </ng-container>
      }

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef class="flex-130px"></mat-header-cell>
        <mat-cell *matCellDef="let entity" class="flex-130px">
          <button mat-button color="primary" (click)="viewShipments(entity.id)" i18n>SHIPMENTS</button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="table.displayColumns$ | async; sticky: true" [style.min-width]="table.minRowWidth$ | async"></mat-header-row>

      <mat-row *matRowDef="let row; columns: table.displayColumns$ | async" [style.min-width]="table.minRowWidth$ | async"></mat-row>

    </mat-table>

  </div>

  <div class="table-footer">
    <div class="selection-buttons">
    </div>
    <mat-paginator
      [pageIndex]="table.currentPageNumber$ | async"
      [length]="table.totalCount$ | async"
      [pageSize]="25"
      [pageSizeOptions]="[10,25,50,100,200]"
      [showFirstLastButtons]="table.showFirstLast$ | async"
      [hidePageSize]="table.hidePageSize$ | async"
      (page)="table.pageChange($event)"
      >
    </mat-paginator>
  </div>
</div>
